// @flow
/* eslint-disable no-inline-comments */
import imported from 'react-imported-component';
import { thenFunction } from '../../utils/imported';

export const AppContextual = imported(() =>
  import(/* webpackChunkName: "AppContextual-Index" */ './AppContextual').catch(() => thenFunction()));
